import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CreationCaptureSegmentationTimingField from '../../../../../form-fields/super-cut/segmentation-timing'
import { CreationCaptureInfoContext } from '../manager'
import SuperCutSegmentationType from '../../../../../../types/super-cut-segmentation-type'

const SegmentationTiming = styled(CreationCaptureSegmentationTimingField)`
    grid-column: span 2;
`

type Props = {
    className?: string
    field: CreationToolSuperCutField
}

const CreationCaptureInfoSegmentationTimingField = ({ className, field }: Props) => {
    const {
        segmentationType,
        segmentationMinLength,
        segmentationMaxLength,
        setSegmentationMinLength,
        setSegmentationMaxLength,
    } = useContext(CreationCaptureInfoContext)

    return (
        <>
            {segmentationType === SuperCutSegmentationType.Scene && (
                <SegmentationTiming
                    {...{
                        className,
                        field,
                        defaultMinLength: segmentationMinLength,
                        defaultMaxLength: segmentationMaxLength,
                        onMinLengthChange: setSegmentationMinLength,
                        onMaxLengthChange: setSegmentationMaxLength,
                    }}
                />
            )}
        </>
    )
}

export default CreationCaptureInfoSegmentationTimingField
